<template>
    <div>
      <Head title="BacktoWorkConnect.ie - Reset Password" /> 
        <v-card elevation="24" style="margin:20px auto;max-width:800px">
            <v-card-title>Reset Password</v-card-title>
            <v-card-text>
                <v-container>
                    
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation>
                    <v-row>
                    <v-col cols="12" lg="12">
                        <v-text-field  v-model="email" disabled label="Email" type="email" required="true"></v-text-field>
                        <v-text-field validate-on-blur :rules="passwordRules" v-model="form.password" label="Password" type="password" required="true"></v-text-field>
                        
                        <v-text-field validate-on-blur v-model="form.password_confirmation" :rules="confirmPasswordRules" label="Confirm Password" type="password" required="true"></v-text-field>
                        <v-btn :disabled="!valid || !token" @click="submitReset()"><v-icon>mdi-send</v-icon> Submit</v-btn>
                    </v-col>
                    </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>  
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue' 
  import Layout from '@/Shared/VuetifyLayout'
  
  export default {
    props: {
      baseurl: String,
      errors: Object,
      token:String,
      email: String,
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            form: this.$inertia.form({
                email: this.email,
                token: this.token,
                password_confirmation: '',
                password: ''
            }),
            valid:false,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid.',
                ],
            
            passwordRules: [
                v => !!v || 'Password is required',
                v => (v.length > 7) || 'Password must have 8 characters.',
                ],
            confirmPasswordRules: [
                v => !!v || 'Please confirm your password',
                v => (v === this.form.password) || 'Passwords must match',
                v => (v.length > 7) || 'Password must have 8 characters.',
            ]
        }
    },
    methods: {
        submitReset() {
        this.form.post('/resetpassword', {
            onSuccess: (res) => {
                console.log('success!',res)
                
            },
            onError: (res) => {
                console.log('error',res)
            },
        })
      }
    }
  }
  </script>
  